import { AccessPermissions } from '../../core/types.js';

/**
 * Means no authentication is required. Use sparingly, only for obvious
 * use cases where the page or action will be public forever (e.g., Home page)
 * For other use cases, define a new PermissionSet so that the definition
 * may change independently later. See storybook for more info.
 */ const PUBLIC = {
    access: AccessPermissions.public
};

export { PUBLIC };
//# sourceMappingURL=public.js.map
